import { render, staticRenderFns } from "./UserEditPage.vue?vue&type=template&id=9a5d9e88&scoped=true"
import script from "./UserEditPage.vue?vue&type=script&lang=ts"
export * from "./UserEditPage.vue?vue&type=script&lang=ts"
import style0 from "./UserEditPage.vue?vue&type=style&index=0&id=9a5d9e88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5d9e88",
  null
  
)

export default component.exports